import React from "react";
import { DATE_FORMAT } from "helpers/common";
import sanitizeHtml from "sanitize-html";
const Columns = ({
  currentPage,
  pageSize,
  handleShowEmails,
  handleForward,
}) => {
  return [
    {
      dataField: "",
      text: "SrNo",
      formatter: (cell, row, rowIndex) => (
        <span className="text-capitalize cursor-pointer">
          {(currentPage - 1) * pageSize + (rowIndex + 1)}
        </span>
      ),
    },
    {
      dataField: "type",
      text: "Type",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">{row.type}</span>
      ),
    },
    {
      dataField: "subject",
      text: "Subject",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">{row.subject}</span>
      ),
    },
    {
      dataField: "message",
      text: "Message",
      formatter: (_, row) => {
        const plainText = sanitizeHtml(row.msg || "", {
          allowedTags: [],
          allowedAttributes: {},
        });
        const truncatedMsg =
          plainText.length > 30
            ? plainText.substring(0, 30) + "..."
            : plainText;
        return (
          <span className="text-capitalize cursor-pointer">{truncatedMsg}</span>
        ); // return <span className="text-capitalize cursor-pointer d-block text-truncate" style={{maxWidth: 100}}>{truncatedMsg}</span>;
      },
    },
    {
      dataField: "attachment",
      text: "Attachment",
      formatter: (_, row) =>
        row.attachment ? (
          <a
            href={row.attachment}
            download
            className="cursor-pointer text-primary"
          >
            Download
          </a>
        ) : (
          "-"
        ),
    },

    {
      text: "Created At",
      dataField: "dateCreated",
      formatter: (_, row) => DATE_FORMAT(row?.createdAt),
    },
    {
      dataField: "email counts",
      text: "Email Count",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row.emails.length}
        </span>
      ),
    },
    {
      text: "Forward",
      dataField: "",
      formatter: (_, row) => (
        <>
          <span className="d-flex gap-1">
            <button
              style={{
                fontSize: "20px",
                color: "red",
                backgroundColor: "#fff",
                border: "none",
              }}
              title="delete"
              onClick={() => handleForward(row)}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.175 11L15.3 7.125C15.1 6.925 15 6.68767 15 6.413C15 6.13834 15.1 5.90067 15.3 5.7C15.5 5.51667 15.7377 5.425 16.013 5.425C16.2883 5.425 16.5173 5.51667 16.7 5.7L21.3 10.3C21.4 10.4 21.471 10.5083 21.513 10.625C21.555 10.7417 21.5757 10.8667 21.575 11C21.5743 11.1333 21.5537 11.2583 21.513 11.375C21.4723 11.4917 21.4013 11.6 21.3 11.7L16.7 16.3C16.5 16.5 16.2667 16.596 16 16.588C15.7333 16.58 15.5 16.484 15.3 16.3C15.1 16.1 14.996 15.8667 14.988 15.6C14.98 15.3333 15.0757 15.1 15.275 14.9L19.175 11ZM13.175 12H7C6.16667 12 5.45833 12.2917 4.875 12.875C4.29167 13.4583 4 14.1667 4 15V18C4 18.2833 3.904 18.521 3.712 18.713C3.52 18.905 3.28267 19.0007 3 19C2.71733 18.9993 2.48 18.9033 2.288 18.712C2.096 18.5207 2 18.2833 2 18V15C2 13.6167 2.48767 12.4377 3.463 11.463C4.43833 10.4883 5.61733 10.0007 7 10H13.175L10.3 7.125C10.1 6.925 10 6.68767 10 6.413C10 6.13834 10.1 5.90067 10.3 5.7C10.5 5.51667 10.7377 5.425 11.013 5.425C11.2883 5.425 11.5173 5.51667 11.7 5.7L16.3 10.3C16.4 10.4 16.471 10.5083 16.513 10.625C16.555 10.7417 16.5757 10.8667 16.575 11C16.5743 11.1333 16.5537 11.2583 16.513 11.375C16.4723 11.4917 16.4013 11.6 16.3 11.7L11.7 16.3C11.5 16.5 11.2667 16.596 11 16.588C10.7333 16.58 10.5 16.484 10.3 16.3C10.1 16.1 9.996 15.8667 9.988 15.6C9.98 15.3333 10.0757 15.1 10.275 14.9L13.175 12Z"
                  fill="black"
                />
              </svg>
            </button>
          </span>
        </>
      ),
    },
    {
      text: "Action",
      dataField: "",
      formatter: (_, row) => (
        <>
          <span className="d-flex ">
            <button
              className="fa fa-eye"
              style={{
                fontSize: "20px",
                color: "green",
                backgroundColor: "#fff",
                border: "none",
              }}
              title="View"
              onClick={() => handleShowEmails(row)}
            ></button>
          </span>
        </>
      ),
    },
  ];
};

export default Columns;
